import {Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ReportService } from '@app/_components/report';
import { TagService } from '../../task/tag/tag.service';
import { TagJoinService } from '../tag-join/tag-join.service';
import { AlertService } from '@app/_services';
import { TagAddModalComponent } from '@app/_components/task/tag/tag-add-modal/tag-add-modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-tag-join-filter-select',
    templateUrl: './tag-join-filter.component.html',
    styleUrls: ['./tag-join-filter.component.css'],
    standalone: false
})
export class TagJoinFilterComponent implements OnInit, OnChanges
{
	texts: string[] = [];

  @Input() filterValue: any;

	tagSelectForm: UntypedFormGroup;

	tagAddModalDialogRef: MatDialogRef<TagAddModalComponent>;

	@Output() messageEvent = new EventEmitter<string>();

	@Output() getFilteredTags = new EventEmitter<string>();

	@Input() tagType: number;
	// inputs
	@Input() tagSource: number;
	@Input() tagSourceId: number;
	tags:any;



	constructor(
		private formBuilder: UntypedFormBuilder,
		private reportService: ReportService,
		private tagService: TagService,
		private tagJoinService: TagJoinService,
		private alertService: AlertService,
		private dialog: MatDialog) { }

	ngOnInit()
	{
	}

	onValueChange(event) {
		this.findTagsWith(this.filterValue);
	}

	findTagsWith(queryString: string)
	{
		//Filter only if query string is not empty
		if(queryString && queryString.length > 0) {
			this.tagJoinService.findTagsWith(queryString, this.tagSource).pipe(first()).subscribe(
				res =>
				{
					console.log(res.data.tagJoin);
					this.getFilteredTags.emit(res.data.tagJoin);
				},
				error =>
				{
					// console.log('reports LIST!: ' + JSON.stringify(error));
					this.alertService.error(error);
				},
				() =>
				{ }
			);
		} else {
			//if query string is empty then return 0 to fetch all records of component
			this.getFilteredTags.emit('0');
		}
	}
	ngOnChanges(changes: SimpleChanges )
	{
		// This is called when the parent updates. When the parent first initializes, it is in add state, and we have no tagSourceId.  This sets the tagSourceId when add is successful.
		if (this.tagSelectForm !== undefined)
		{
			this.tagSelectForm.patchValue({ tagSourceId: this.tagSourceId });
		}
    if (changes?.filterValue?.previousValue !== changes?.filterValue?.currentValue){
      this.findTagsWith(changes.filterValue.currentValue);
    }
	}
}
